import * as React from "react";
import * as shortid from "shortid";
import cx from "classnames";
// import { pure } from 'recompose';
import * as Lodash from "lodash";
// import * as i18next from 'i18next';

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    source,
    target,
    morePath,
    drawZone,
    xySVGCircle,
    onGetMouseCoord,
    coordString,
    coordStringMouseOver,
    onGetMouseOverCoord,
  } = props;
  /**
   * @description : double click
   * @method
   * @name PathSVGElement
   * @param { }
   * @return { void  }
   */
  props.PathSVGElement();

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @name shortid
   * @infos "https://reactjs.org"
   */

  return (
    <div
      className="masque-tunnel"
      onMouseOver={onGetMouseOverCoord}
      onClick={onGetMouseCoord}
    >
      <img src={target} className="bg-image video-camera" />
      <img src={source} className={cx("masqueAll")} />

      {drawZone && (
        <div
          className="polygone-class"
          id="PathSVGElement"
          key={shortid.generate()}
        >
          <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            overflow="visible"
          >
            <path
              d={coordStringMouseOver}
              strokeWidth="2"
              style={{ stroke: "yellow", fill: "#435ee173" }}
            />
            <path
              d={coordString}
              strokeWidth="2"
              style={{ stroke: "yellow", fill: "#435ee173" }}
            />
            {morePath &&
              !Lodash.isUndefined(morePath) &&
              morePath.map((element: any, index: any) => {
                return (
                  <path
                    key={shortid.generate()}
                    id={index}
                    d={element}
                    strokeWidth="2"
                    style={{ stroke: "yellow", fill: "#435ee173" }}
                    className="pathSVG"
                  />
                );
              })}
            {xySVGCircle &&
              !Lodash.isUndefined(xySVGCircle) &&
              xySVGCircle.map((element: any, index: any) => {
                return (
                  <circle
                    key={shortid.generate()}
                    cx={element.xCoord}
                    cy={element.yCoord}
                    r="1"
                    style={{ stroke: "#ed5b56", fill: "#ed5b56" }}
                  />
                );
              })}
          </svg>
        </div>
      )}
    </div>
  );
};

// initialisation des props
Component.defaultProps = {
  drawZone: false,
  source: "",
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  source?: any;
  target?: any;
  morePath?: any;
  drawZone?: any;
  xySVGCircle?: any;
  onGetMouseCoord?: any;
  PathSVGElement?: any;
  coordString?: any;
  coordStringMouseOver?: any;
  onGetMouseOverCoord?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/pathSVG/component.tsx